import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-skeleton-wizard-time-list',
  templateUrl: './skeleton-wizard-time-list.component.html',
  styleUrls: ['./skeleton-wizard-time-list.component.scss']
})
export class SkeletonWizardTimeListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
